import { BaseService, DataResponse } from './base.service';

class StatusService extends BaseService {
  private url: string = '/api';

  constructor() {
    super();
  }

  public async getVersion(): Promise<DataResponse<{ version: string }>> {
    const res = await this.$http.get<{ version: string }>(`${this.url}/status`);

    return {
      status: true,
      data: res.data,
    };
  }
}

export default new StatusService();
